<template>
  <h3>Logout View</h3>
</template>

<script>
export default {
    components: {},
    computed: {},
    mounted() {
        this.$nextTick(() => {
            this.$store.dispatch('auth/logout');
            this.$store.dispatch('user/clearUserData');
            this.$store.dispatch('toolbar/reloadMenuItems');
        });
    }
};
</script>
